import React from 'react';
import Typography from '@material-ui/core/Typography';
import FirebaseImageButton from '../../customComponents/button/FirebaseImageButton';
import { ITransformerMunicipalityReading } from '../../../@types/model/transformer/reading/transformerMunicipalityReading';

interface IMunicipalityReadingEntryViewProps {
    reading : ITransformerMunicipalityReading;
}

interface IMunicipalityReadingEntryViewState {}

export default class MunicipalityReadingEntryView extends React.Component<IMunicipalityReadingEntryViewProps, IMunicipalityReadingEntryViewState> {
    constructor(props : IMunicipalityReadingEntryViewProps) {
        super(props);
        this.state = {};
    }

    public readonly render = () => {
        const { reading } = this.props;
        return (
            <div className='fdc'>
                {
                    !!reading.transformerMeterNumberReadings.length &&
                    <div className='fdr flx1'>
                        <div className={'fdc flx1 m10'}>
                            <Typography className={'fdr bcDarkBlue fw700 cw mb10 p10 mt10'} variant='h6'>
                                READINGS
                            </Typography>
                            {
                                reading.transformerMeterNumberReadings.map(n => (
                                    <div key={`${n.itemNumber}_${n.meterNumber}_reading`} className={'fdc'}>
                                        <div className={'fdr pl10 pr10 pt10 mb10'}>
                                            <Typography className={'flx1 fw600 bbw1 bocGrey pb10 pl10 pr10 jcc'} variant='subtitle1'>
                                                NUMBER (M{n.itemNumber})
                                            </Typography>
                                            <Typography className={'flx1 fw600 bbw1 bocGrey pb10 pl10 pr10 jcc'} variant='subtitle1'>
                                                NUMBER OF DIGITS (M{n.itemNumber})
                                            </Typography>
                                            <Typography className={'flx1 fw600 bbw1 bocGrey pb10 pl10 pr10 jcc'} variant='subtitle1'>
                                                READING (M{n.itemNumber})
                                            </Typography>
                                            <Typography className={'flx1 fw600 bbw1 bocGrey pb10 pl10 pr10 jcc'} variant='subtitle1'>
                                                USAGE (M{n.itemNumber})
                                            </Typography>
                                            <Typography className={'flx1 fw600 bbw1 bocGrey pb10 pl10 pr10 jcc'} variant='subtitle1'>
                                            </Typography>
                                        </div>
                                        <div className={'fdr mb10 pl10 pr10'}>
                                            <Typography className={'flx1 pl10 pr10 mnh48 jcc'} variant='subtitle1'>
                                                {n.meterNumber}
                                            </Typography>
                                            <Typography className={'flx1 pl10 pr10 mnh48 jcc'} variant='subtitle1'>
                                                {n.numberOfDigits}
                                            </Typography>
                                            <Typography className={'flx1 pl10 pr10 mnh48 jcc'} variant='subtitle1'>
                                                {n.reading}
                                            </Typography>
                                            <Typography className={'flx1 pl10 pr10 mnh48 jcc'} variant='subtitle1'>
                                                {n.usage}
                                            </Typography>
                                            <div className={'flx1 pl10 pr10 mnh48 jcc'}>
                                                {
                                                    n.imageFileName &&
                                                    <FirebaseImageButton fileName={n.imageFileName} path={`electricalpoint/${reading.transformerRef}/municipality_readings`} />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                }
            </div>
        );
    };
}
